<template>
  <div :class="groupClass">
    <label :class="lableClass" :for="name">
      <slot>{{ title }}</slot>
    </label>

    <div :class="fieldClass">
      <!--Special Part Starts-->
      <multiselect
        :clear-on-select="!multiple"
        :close-on-select="!multiple"
        :custom-label="fullname"
        :hide-selected="multiple"
        :internal-search="false"
        :limit="50"
        :limit-text="limitText"
        :loading="!ready"
        :multiple="multiple"
        :options="options"
        :options-limit="50"
        :placeholder="placeholder.length > 0 ? placeholder : 'Type to search'"
        :preserve-search="multiple"
        :show-labels="false"
        :value="value"
        label="email"
        track-by="id"
        @input="update"
        @search-change="asyncFind"
      >
        <template #noResult>
          <slot name="no-result">Oops! No result found.</slot>
        </template>
      </multiselect>
      <!--Special Part Ends-->

      <div
        v-if="form && form.errors.has(errorId)"
        class="invalid-feedback"
        v-text="form.errors.get(errorId)"
      ></div>
      <slot name="note"></slot>
    </div>

    <div :class="extraSlotClass">
      <slot name="extra">
        <button
          v-if="showResetButton"
          class="btn btn-danger"
          type="button"
          @click.prevent="resetUser()"
        >
          <font-awesome-icon :icon="['fal', 'times']" />
        </button>
      </slot>
    </div>
  </div>
</template>

<script type="text/babel">
import debounce from "debounce";
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  props: {
    filterByBrandId: {
      default: false,
    },
    hasCustomer: {
      default: false,
    },
    userRole: {
      default: "technician",
    },
    state: {
      type: String,
      required: false,
      default: null,
    },
    multiple: {
      default: false,
    },
    showResetButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    bypassFilter: {
      type: String,
      required: false,
      default: null,
    },
  },

  methods: {
    resetUser() {
      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("change", null);
    },

    update(object) {
      if (object !== undefined && object !== null) {
        this.form[this.name] = object.id;
      }

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("change", object);
    },

    fullname(user) {
      if (user.name) {
        if (user.customers && user.customers.length > 0) {
          return `${user.name} [Tech Booking]`;
        }

        return user.name;
      }

      return "";
    },

    limitText(count) {
      return `and ${count} other users`;
    },

    /* eslint-disable func-names */
    asyncFind: debounce(function (query) {
      if (query.length < 2) {
        return;
      }

      this.ready = false;

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      let filter = this.filterByBrandId ? `&brand_id=${this.filterByBrandId}` : "";
      if (this.state) {
        filter += `&state=${this.state}`;
      }

      const hasCustomer = this.hasCustomer ? `&has_customer=${this.hasCustomer}` : "";

      const bypassFilter = this.bypassFilter ? `&bypass_filter=${this.bypassFilter}` : "";

      this.$http
        .get(
          `/users?active=true&role=${this.userRole}&search=${query}&limit=50${filter}${hasCustomer}${bypassFilter}`
        )
        .then((response) => {
          this.options = response.body.data;
          this.ready = true;
        });
    }, 500),
  },
};
</script>
